import PropTypes from "prop-types";
import React, { useEffect, useState, useContext } from "react";
import { Icon } from "@iconify/react";
import menu2Fill from "@iconify/icons-eva/menu-2-fill";
import { alpha, styled } from "@mui/material/styles";
import {
  Box,
  Stack,
  AppBar,
  Container,
  Toolbar,
  Typography,
  IconButton,
  Paper,
} from "@mui/material";
import useCollapseDrawer from "../../hooks/useCollapseDrawer";
// components
import { MHidden } from "../../components/@material-extend";
import AccountPopover from "./AccountPopover";
import NotificationsPopover from "./NotificationsPopover";
import useAuth from "src/hooks/useAuth";
import MessagessPopover from "./MessagesPopover";
import { ClientContext } from "../../contexts/ClientContext";

const DRAWER_WIDTH = 200;
const COLLAPSE_WIDTH = 52;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 22;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(1, 2),
  },
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const { page, setPage } = useContext(ClientContext);
  const { isCollapse } = useCollapseDrawer();
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    setPage({
      ...page,
      title: `Hello ${user?.first_name}`,
      description: "Access our services seemlessly",
    });
  }, []);

  return (
    <RootStyle
      sx={{
        background: "#FFFAF3",
        ...(isCollapse && {
          width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` },
        }),
      }}
    >
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton
            onClick={onOpenSidebar}
            sx={{ 
              mr: { xs: 0.5, sm: 1 }, 
              color: "text.primary",
              padding: { xs: "8px", sm: "12px" },
            }}
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>

        {/* Title and Description - Responsive sizing */}
        <Box sx={{ flex: 1, minWidth: 0, mr: { xs: 1, sm: 2 } }}>
          <Typography
            variant="body2"
            sx={{
              color: "text.primary",
              fontSize: { xs: "14px", sm: "16px", md: "18px" },
              fontWeight: "700",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {page?.title}
          </Typography>
          
          {/* Description - Hidden on mobile */}
          <Typography
            variant="body2"
            sx={{
              display: { xs: "none", sm: "block" },
              color: "text.secondary",
              fontSize: { sm: "11px", md: "12px" },
              fontWeight: "300",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {page?.description}
          </Typography>
        </Box>

        {/* Right side icons/buttons */}
        <Stack
          direction="row"
          alignItems="center"
           spacing={{ xs: 0.5, sm: 1, md: 1.5 }}
          // sx={{ flexShrink: 0 }}
        >
          {page?.showButton && page?.buttonComponent}
          
          <MessagessPopover />
          <NotificationsPopover />
          
          {/* AccountPopover - Hidden on small mobile, shown on larger screens */}
          <Box 
            sx={{ 
              display: { xs: "none", sm: "flex" },
            }}
          >
            <AccountPopover />
          </Box>
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}